// extracted by mini-css-extract-plugin
export default {"logo":"not-found-page__logo___Ypw4u"};